// components/LocalTaskForceRequirements.jsx

import React from "react";
import { Box, Paper, Typography } from "@mui/material";

export default function LocalTaskForceRequirements({
  localTaskForceMembers,
}) {
  const totalMembers = localTaskForceMembers.length;

  const maleCount = localTaskForceMembers.filter(
    (m) => m.gender?.toLowerCase() === "male"
  ).length;

  const femaleCount = localTaskForceMembers.filter(
    (m) => m.gender?.toLowerCase() === "female"
  ).length;

  const malePercentage =
    totalMembers > 0
      ? Math.round((maleCount / totalMembers) * 100)
      : 0;

  const femalePercentage =
    totalMembers > 0
      ? Math.round((femaleCount / totalMembers) * 100)
      : 0;

  const maleValid = malePercentage >= 40;
  const femaleValid = femalePercentage >= 40;

  const hasGrue = localTaskForceMembers.some(
    (member) => Boolean(member.grue?.trim())
  );

  return (
    <Paper
      sx={{
        p: 2.5,
        mb: 3,
        borderRadius: 3,
        background: "#F8FBFC",
        border: "1px solid #D6E4EA",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          color: "#23576B",
          mb: 2,
        }}
      >
        Local Task Force Requirements Status
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {/* GRUE */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "#344054" }}>
            At least 1 GRUE representative
          </Typography>

          <Box
            sx={{
              px: 1.5,
              py: 0.5,
              borderRadius: 5,
              fontWeight: 700,
              fontSize: "0.75rem",
              background: hasGrue
                ? "#ECFDF3"
                : "#FEF3F2",
              color: hasGrue
                ? "#027A48"
                : "#B42318",
            }}
          >
            {hasGrue ? "✓ Included" : "Missing"}
          </Box>
        </Box>

        {/* GENDER REPRESENTATION */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Typography sx={{ color: "#344054" }}>
              No less than a 40% representation of each gender
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              {/* MALE */}
              <Box
                sx={{
                  px: 1.2,
                  py: 0.4,
                  borderRadius: 5,
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  background: maleValid
                    ? "#ECFDF3"
                    : "#FEF3F2",
                  color: maleValid
                    ? "#027A48"
                    : "#B42318",
                }}
              >
                Male {malePercentage}%
              </Box>

              {/* FEMALE */}
              <Box
                sx={{
                  px: 1.2,
                  py: 0.4,
                  borderRadius: 5,
                  fontSize: "0.75rem",
                  fontWeight: 700,
                  background: femaleValid
                    ? "#ECFDF3"
                    : "#FEF3F2",
                  color: femaleValid
                    ? "#027A48"
                    : "#B42318",
                }}
              >
                Female {femalePercentage}%
              </Box>
            </Box>
          </Box>

          {/* COMBINED BAR */}
          <Box
            sx={{
              width: "100%",
              height: 14,
              borderRadius: 999,
              background: "#E4E7EC",
              overflow: "hidden",
              display: "flex",
            }}
          >
            {/* MALE SEGMENT */}
            <Box
              sx={{
                width: `${malePercentage}%`,
                background:
                  "linear-gradient(90deg, #23576B, #3A7288)",
                transition: "0.3s ease",
              }}
            />

            {/* FEMALE SEGMENT */}
            <Box
              sx={{
                width: `${femalePercentage}%`,
                background:
                  "linear-gradient(90deg, #C15C99, #D97BB0)",
                transition: "0.3s ease",
              }}
            />
          </Box>

          {/* LEGEND */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              mt: 0.5,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.7,
              }}
            >
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  background: "#23576B",
                }}
              />

              <Typography
                variant="body2"
                sx={{ color: "#667085" }}
              >
                Male
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.7,
              }}
            >
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  background: "#C15C99",
                }}
              />

              <Typography
                variant="body2"
                sx={{ color: "#667085" }}
              >
                Female
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}